import { Injectable } from '@angular/core';
import { Notification, UtilService, ApiService } from '../../shared/index';
import { MemberActivityTypeModel } from './member-activity-type.model';
import { IMemberService } from './imember.service';
import { DropMembershipSettings } from './drop-membership-setttings.model';
import { ProfileServiceApiService } from 'src/app/shared/api/profile-service-api.service';

@Injectable()
export class MemberService implements IMemberService {
  public _utilService: UtilService;
  public _apiService: ApiService;

  public constructor(utilService: UtilService, apiService: ApiService, private _profileServiceApiService: ProfileServiceApiService) {
    this._utilService = utilService;
    this._apiService = apiService;
  }

  public getDropMembershipSettings(): Promise<DropMembershipSettings> {
    return this._apiService.get('ConfigSettings/DropMembershipSettings');
  }

  public getDropMembershipSettingsBatches(): Promise<string[]> {
    return this._apiService.get('ConfigSettings/DropMembershipSettings/SettingBatches');
  }

  public getMemberActivityTypes(): Promise<Array<MemberActivityTypeModel>> {
    return this._apiService.get('Membership/GetMemberActivityTypes');
  }

  public getMemberActivityDropCodes(): Promise<Array<MemberActivityTypeModel>> {
    return this._apiService.get('Membership/MemberActivityTypes/DropCodes');
  }

  public getMemberSinceDate(id: number): Promise<Date> {
    return this._profileServiceApiService.get(`/profile/v2/Membership/${id}/MemberSince`);
  }
}
